import AdvancedSearch from "./AdvancedSearch.vue";

export default AdvancedSearch;